import type { BadgeProps } from '@/design-system/primitives/Badge';

/** Shared UI helpers for the support/exception board. */
export function requiresClinicalResolution(ticket: {
  source?: string | null;
  missing_info_flag_id?: string | null;
}): boolean {
  return ticket.source === 'missing_info' || Boolean(ticket.missing_info_flag_id);
}

export function canSetGenericTicketState(
  ticket: { source?: string | null; missing_info_flag_id?: string | null },
  state: string,
): boolean {
  // Resolved always requires a reason through the dedicated resolve endpoint.
  return state !== 'resolved' && !(state === 'fixed' && requiresClinicalResolution(ticket));
}

export const DISPOSITION_TONE: Record<string, NonNullable<BadgeProps['tone']>> = {
  compliance: 'danger',
  clinical: 'warning',
  ops: 'info',
  auto_resolvable: 'accent',
  unclassified: 'neutral',
};

export const DISPOSITIONS = [
  'compliance',
  'clinical',
  'ops',
  'auto_resolvable',
  'unclassified',
] as const;

export function ageLabel(iso: string | null | undefined): string {
  if (!iso) return '';
  const ms = Date.now() - new Date(iso).getTime();
  if (Number.isNaN(ms)) return '';
  const mins = Math.floor(ms / 60000);
  if (mins < 60) return `${Math.max(mins, 0)}m`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 48) return `${hrs}h`;
  return `${Math.floor(hrs / 24)}d`;
}

export function isOverdue(slaDueAt: string | null | undefined): boolean {
  if (!slaDueAt) return false;
  const due = new Date(slaDueAt).getTime();
  return !Number.isNaN(due) && due < Date.now();
}
